import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Tooltip from '@mui/material/Tooltip';

import Flag from 'src/common/components/flags/Flag';
import { LANGUAGES, LanguageKeys } from 'src/common/constants/languages';

interface Props {
  value: LanguageKeys;
  onChange: (lang: LanguageKeys) => void;
}

export function LanguageFlagButtons({ value, onChange }: Props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
      {LANGUAGES.map(({ code, nativeName }) => (
        <Tooltip key={code} title={nativeName}>
          <IconButton
            size="small"
            aria-label={nativeName}
            aria-pressed={value === code}
            onClick={() => onChange(code)}
            sx={{
              p: 0.25,
              borderRadius: 0.5,
              border: '1px solid',
              borderColor: value === code ? 'primary.main' : 'transparent',
              opacity: value === code ? 1 : 0.5,
              '&:hover': { opacity: 1 },
            }}
          >
            <Flag code={code} width={18} height={18} />
          </IconButton>
        </Tooltip>
      ))}
    </Box>
  );
}

export default function LanguageFlagSwitcher({ value, onChange }: Props) {
  return (
    <InputAdornment position="end">
      <LanguageFlagButtons value={value} onChange={onChange} />
    </InputAdornment>
  );
}
